/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import { imsize } from '../markdown-it-plugins/markdown-it-imsize'
import { link } from '../markdown-it-plugins/markdown-it-links'
import { MarkdownParser } from '../from_markdown'
import { Schema } from 'prosemirror-model'
import { buildTokensForSchema } from './tokens'

const markdownit = require('markdown-it')

export function CommonMarkParser(schema: Schema) {
  const parser = markdownit({ html: false })
  parser.use(imsize)
  parser.use(link)
  return new MarkdownParser(schema, parser, buildTokensForSchema(schema))
}
